import { User } from "~/common/Store/models/User";
import {
  ExpandedDescriptionTextSectionTypes,
  ProductDetailPageResult,
  SpecificationTable,
  Templates,
} from "../ProductDetailPageResult";
import { getOfferSchema } from "./OfferSchema";

export interface GroupInStockOptions {
  hasInStock?: boolean;
  hasOutOfStock?: boolean;
  hasExclusive?: boolean;
  hasSpecialOrder?: boolean;
}

export function getSpecification(
  specificationTable: SpecificationTable,
  specificationName: string
): string {
  if (specificationTable?.specifications) {
    return specificationTable.specifications
      .filter(
        (x: { classification: string }) =>
          x.classification === specificationName
      )
      ?.map((y) => y.types.map((z) => z.value))
      ?.flat()
      .join(", ");
  }
  return "";
}

export const getAndTrimDescription = (product: ProductDetailPageResult) => {
  const {
    template,
    extendedDescription,
    expandedDescription,
    outletAttributes,
  } = product;
  let description = extendedDescription;

  if (template === Templates.ExpandedDescriptionTemplate) {
    description =
      expandedDescription.sections.find(
        (x) => x.type === ExpandedDescriptionTextSectionTypes.Introduction
      )?.body || extendedDescription;
  } else if (template === Templates.OutletTemplate) {
    description = outletAttributes?.highlights ?? extendedDescription;
  }
  return description
    .replace(/(<([^>]+)>)/gi, " ")
    .replace(/ +/g, " ")
    .trim();
};

export const getSpecificationProperties = (
  specificationTable: SpecificationTable
) => {
  return {
    ...(getSpecification(specificationTable, "Color") !== ""
      ? {
          color: getSpecification(specificationTable, "Color"),
        }
      : undefined),
    ...(getSpecification(specificationTable, "Material") !== ""
      ? {
          material: getSpecification(specificationTable, "Material"),
        }
      : undefined),
    ...(getSpecification(specificationTable, "Pattern") !== ""
      ? {
          pattern: getSpecification(specificationTable, "Pattern"),
        }
      : undefined),
  };
};

export const getRepeatedProductSchemaProperties = (
  domain: string,
  imageDomain: string,
  product: ProductDetailPageResult,
  user: User,
  isGoogleView: boolean,
  groupInStockOptions?: GroupInStockOptions
) => {
  const { link, specificationTable } = product;
  const primaryImage =
    product.productImages.find((img) => img.isPrimaryDetailImage) ??
    product.productImages[0];

  return {
    "@type": "Product",
    url: domain + link,
    name: product.header,
    gtin: product.seoUpc,
    image: `${imageDomain}${primaryImage?.large}` || "",
    itemCondition:
      product.template === Templates.OutletTemplate
        ? "https://schema.org/DamagedCondition"
        : "https://schema.org/NewCondition",
    description: getAndTrimDescription(product),
    ...getSpecificationProperties(specificationTable),
    offers: getOfferSchema(
      domain,
      product,
      user,
      isGoogleView,
      groupInStockOptions
    ),
  };
};
